<template>
  <div id="vue-grapesjs"></div>
</template>
<script>
import grapesjs from 'grapesjs'
import 'grapesjs/dist/css/grapes.min.css'
import './newsletter.js'
import './editor_rte.js'


export default {
  name: 'app',

  props: {
    id: {
      default: 0
    },
    is_template: {
      default: 0
    },
    subject: {
      default: ''
    },
    content: {
      default: ''
    }
  },
  data () {
    return {

    }
  },

  mounted () {

    this.editor = grapesjs.init({
      container : '#vue-grapesjs',
      height: '100%',
      exportWrapper: 1,
      fromElement: false,
      storageManager: {
        id: 'gjs-',             // Prefix identifier that will be used on parameters
        type: 'local',          // Type of the storage
        autosave: false,         // Store data automatically
        autoload: false,         // Autoload stored data on init
        stepsBeforeSave: 1,     // If autosave enabled, indicates how many changes are necessary before store method is triggered
      },
      // plugins: ['gjs-preset-newsletter'],
      plugins: ['gjs-preset-newsletter', 'gjs-plugin-rte'],
      pluginsOpts: {
        'gjs-preset-newsletter': {
          modalLabelImport: 'Paste all your code here below and click import',
          modalLabelExport: 'Copy the code and use it wherever you want',
          codeViewerTheme: 'material',
          //defaultTemplate: templateImport,
          cellStyle: {
            'font-size': '12px',
            'font-weight': 300,
            'vertical-align': 'top',
            // color: 'rgb(111, 119, 125)',
            margin: 0,
            padding: 0,
          },
        },

        // 'gjs-plugin-ckeditor': {
        //   position: 'center',
        //   options: {
        //     language: 'fr',
        //     skin: 'moono-dark',
        //   }
        // }
      }
    });
    // Force body to be white initialy
    const frameBody = this.editor.Canvas.getBody()
    const domComponents = this.editor.DomComponents;
    const wrapper = domComponents.getWrapper();
    wrapper.set('style', {'background-color': '#FFFFFF'});

    // Set editor content from prop
    this.editor.setComponents(this.content)
    // Keep track of vue instance inside editor
    this.editor.vueEl = this
    // Old school way of setting title in input inside grapesjs inerface
    this.subject_input = document.getElementById('gjs-messsage-subject-input')
    this.subject_input.value = this.subject

  }
}
</script>

<style>
.gjs-pn-devices-c {
  padding: 2px 5px 2px 5px;
}

.gjs-editor i.fa { /*** quick dirty fix for css collision with framework's icons ***/
  font-size: 12px;
  font-weight: normal;
}

#gjs-messsage-subject-input {
  background-color: #f5f5f5;
  margin-top: 2px;
  margin-left: 40px;
  width: 600px;
}

</style>
